import { Input } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import { Country } from '@prisma/client';
import Required from '../FormElements/Required';

export const CompanyNameInput = ({
  label,
  error,
  onValueChange,
  nameValidationOptions,
  value,
  placeholder,
  labelClassname,
  inputClassname,
}: {
  label: string;
  labelClassname?: string;
  inputClassname?: string;
  error?: string;
  onValueChange: (val: string) => void;
  value: string;
  placeholder?: string;
  nameValidationOptions: {
    country: Country;
    companyDescription?: string;
    entityType?: string;
    industry?: string;
  };
}) => {
  return (
    <div>
      <div
        className={cn('pb-2 text-base font-500 text-neutral-1', labelClassname)}
      >
        {label} <Required />
      </div>
      <Input
        onChange={(e) => {
          onValueChange(e.target.value);
        }}
        placeholder={placeholder}
        value={value}
        className={cn('text-primary-1 py-2.5 px-3', inputClassname)}
        error={error}
      />
    </div>
  );
};
